import React from 'react';

/*
import {
  hf,
  ht,
  cr,
  a,
  l,
  IptC,
  LblC,
  GridC,
  TextC,
} from 'lib';
*/
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';
import * as hf from './_hf';

let $i1z4z = {} as ht.dz;

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    i1z4z: ht.dz,
  }
}) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    $i1z4z = pz.cz.i1z4z;
  }, [
    pz.cz.i1z4z,
  ])

  const _abtz = {
    rowz: a(`bc/lt9 bwl/1 bwr/1 bwb/1 f/n mb/0`),
    lblz: a(`bc/lt9 bwh/1 dh/f f/1 fd/rcc`),
    bdyz: a(`dw/83 f/n`),
    cellz0: a(`dh/f dw/9 f/n fd/rcc ph/0.5 sc/t`),    
    cellz1: a(`dh/f dw/9 f/n fd/rcc ph/0.5 sc/lt2`),    
    iptz: a(`ta/r`),
    bsdz: a(`dw/3`),
    ttlz: a(`bc/lt9 bwl/1 dh/f f/1.5 sc/lt2`),
  };

//hf.l(`icvI1zS11Co3g 43: here`);
  return (
    cr.c(GridC.N, {
      key: -70,
      abtType: 'nolineCmnz',
      lineCs: [
        {
          boxStlz: {
            ... _abtz.rowz,
            ... a(`bc/lt9 bwv/1`),
          },
          cellCs: [
            {
              boxStlz: _abtz.lblz,
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'lblStfz',
                  textz: {
                    pfx: '性別',
                  }
                })
              ]
            },
            {
              boxStlz: _abtz.bdyz,
              oClds: [
                cr.c(GridC.N, {
                  key: -10,
                  abtType: `nolineCmnz`,
//                  boxStlz: a(`pt/0.5`),
                  boxStlz: a(`dh/f`),
                  lineCs: [
                    {
                      boxStlz: a(`dh/4`),
                      cellCs: [
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '男性',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a1100i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a1100i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '女性',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a1200i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a1200i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          oClds: [
                          ]
                        },

                      ]
                    }
                  ]
                })
              ]
            },
            {
//              boxStlz: a('bc/lt9 bwl/1 dh/f dw/18 f/n sc/lt2'),
              boxStlz: _abtz.ttlz,
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  lblCz: {
                    boxStlz: a('dw/6'),
                    textz: {
                      pfx: '合計',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        iptStlz: {
                          ... _abtz.iptz,
                          ... a(`sc/t`),
                        },
                        cz: {
                          bEdit: false,
                          iptType: 'text',
                          vle: ($i1z4z.i1z4a1100i ?? 0) + ($i1z4z.i1z4a1200i ?? 0),
                        }
                      }),
                      cr.c(TextC.N, {
                        key: -20,
                        abtType: 'bsdCmnz',
                        boxStlz: _abtz.bsdz,
                        textz: {
                          pfx: '人',
                        }
                      })
                    ],
                  }
                }),
              ]
            },
          ]
        },
        {
          boxStlz: _abtz.rowz,
          cellCs: [
            {
              boxStlz: _abtz.lblz,
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'lblStfz',
                  textz: {
                    pfx: '階層別',
                  }
                })
              ]
            },
            {
              boxStlz: _abtz.bdyz,
              oClds: [
                cr.c(GridC.N, {
                  key: -10,
                  abtType: 'nolineCmnz',
//                  boxStlz: a(`pt/0.5`),
//                  boxStlz: a(`dh/f`),
                  lineCs: [
                    {
//                      boxStlz: a(`mb/0`),
//                      boxStlz: a(`dh/4`),
                      cellCs: [
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '幼児',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '小学生',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '中学生',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '高校生',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '大学生',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: {
                            ... _abtz.cellz1,
                            ... a('dw/18')
                          },
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '一般',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: {
                            ... _abtz.cellz0,
                            ... a('dw/18')
                          },
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '65歳以上',
                              }
                            }),
                          ]
                        },
                      ]
                    },
                    {
//                      boxStlz: a(`mb/0`),
//                      boxStlz: a(`dh/4`),
                      cellCs: [
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '　',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '　',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '男性',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '女性',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '男性',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '女性',
                              }
                            }),
                          ]
                        },
                      ]
                    },
                    {
//                      boxStlz: a(`mb/0`),
//                      boxStlz: a(`dh/4`),
                      cellCs: [
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [ // 幼児
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2100i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2100i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [ // 小学生
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2200i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2200i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [ // 中学生
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2300i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2300i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [ // 高校生
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2400i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2400i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [ // 大学生
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2500i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2500i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [ // 一般男性
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2600i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2600i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [ // 一般女性
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2700i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2700i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [ // シニア男性
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2800i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2800i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [ // シニア女性
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a2900i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a2900i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                      ]
                    },
                  ]
                })
              ]
            },
            {
//              boxStlz: a('bc/lt9 bwl/1 dh/f dw/18 f/n sc/lt2'),
//              boxStlz: a('bc/lt9 bwl/1 dh/f f/1.5 sc/lt2'),
              boxStlz: _abtz.ttlz,
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  lblCz: {
                    boxStlz: a('dw/6'),
                    textz: {
                      pfx: '合計',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        iptStlz: {
                          ... _abtz.iptz,
                          ... a(`sc/t`),
                        },
                        cz: {
                          bEdit: false,
                          iptType: 'text',
                          vle: ($i1z4z.i1z4a2100i ?? 0) + ($i1z4z.i1z4a2200i ?? 0) + ($i1z4z.i1z4a2300i ?? 0) + ($i1z4z.i1z4a2400i ?? 0) + ($i1z4z.i1z4a2500i ?? 0) + ($i1z4z.i1z4a2600i ?? 0) + ($i1z4z.i1z4a2700i ?? 0) + ($i1z4z.i1z4a2800i ?? 0) + ($i1z4z.i1z4a2900i ?? 0),
                        }
                      }),
                      cr.c(TextC.N, {
                        key: -20,
                        abtType: 'bsdCmnz',
                        boxStlz: _abtz.bsdz,
                        textz: {
                          pfx: '人',
                        }
                      })
                    ],
                  }
                }),
              ]
            },
          ]
        },
        {
//          boxStlz: a(`bc/lt9 bw/1 f/n`),
          boxStlz: {
            ... _abtz.rowz,
//            ... a(`dh/6`)
          },
          cellCs: [
            {
//              boxStlz: a('bc/lt9 bwr/1 dh/f dw/10 f/n'),
              boxStlz: _abtz.lblz,
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  abtType: 'lblStfz',
                  textz: {
                    pfx: '住居区分',
                  }
                })
              ]
            },
            {
              boxStlz: {
                ... _abtz.bdyz,
              },
              oClds: [
                cr.c(GridC.N, {
                  key: -10,
                  abtType: 'nolineCmnz',
                  boxStlz: a(`dh/f`),
                  lineCs: [
                    {
                      boxStlz: a(`dh/4`),
                      cellCs: [

                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '区内',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a3100i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a3100i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '区外',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz1,
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a3200i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a3200i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(TextC.N, {
                              key: -10,
                              abtType: 'lblStfz',
                              textz: {
                                pfx: '市外',
                              }
                            }),
                          ]
                        },
                        {
                          boxStlz: _abtz.cellz0,
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              iptStlz: _abtz.iptz,
                              cz: {
                                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                                iptType: 'text',
                                vle: $i1z4z.i1z4a3300i ?? 0,
                                onChg: ( _s: ht.s ) => {
                                  $i1z4z.i1z4a3300i = Number(_s);
                                  _frcUdt();
                                }
                              }
                            }),
                            cr.c(TextC.N, {
                              key: -20,
                              abtType: 'bsdCmnz',
                              boxStlz: _abtz.bsdz,
                              textz: {
                                pfx: '人',
                              }
                            })
                          ]
                        },
                        {
                          oClds: [
                          ]
                        },

                      ]
                    }
                  ]
                })
              ]
            },
            {
//              boxStlz: a('bc/lt9 bwl/1 dh/f f/1.5 sc/lt2'),
              boxStlz: _abtz.ttlz,
              oClds: [
                cr.c(LblC.N, {
                  key: -10,
                  abtType: 'hzlStfz',
                  lblCz: {
                    boxStlz: a('dw/6'),
                    textz: {
                      pfx: '合計',
                    }
                  },
                  cttCz: {
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        iptStlz: a(`ta/r sc/t`),
                        cz: {
                          bEdit: false,
                          iptType: 'text',
                          vle: ($i1z4z.i1z4a3100i ?? 0) + ($i1z4z.i1z4a3200i ?? 0) + ($i1z4z.i1z4a3300i ?? 0),
                        }
                      }),
                      cr.c(TextC.N, {
                        key: -20,
                        abtType: 'bsdCmnz',
                        boxStlz: _abtz.bsdz,
                        textz: {
                          pfx: '人',
                        }
                      })
                    ],
                  }
                }),
              ]
            },
          ]
        },
      ]
    })
  );
};
